import { FC } from 'react'
import Slider from 'react-slick'

const SlickSlider: FC<any> = (props) => (
  <>
    <Slider {...props} />
  </>
)
export default SlickSlider
